<template>
  <Dialog
    header="Conta Inadimplente"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :style="{ width: '35vw' }"
    :modal="true"
    :closable="false"
  >
    <p style="text-align: justify">
      Sua conta está inadimplente, entre em contato com a administração para a
      emissão de um novo boleto. Após regularização do pagamento seu acesso será
      liberado novamente.
    </p>
    <template #footer>
      <Button
        label="Fechar"
        class="p-button-danger"
        @click="$emit('update:visible', false)"
      />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'AccountWarningDefaulting',
  props: {
    visible: Boolean,
    account: Object,
  },
};
</script>

<style scoped>
</style>